angular.module('jv.source.modal-adapter.service', [
    'jv.Common.Modal'
])
.value('modalTemplateUrl', 'htm/common/modal.html')
.service('sourceModalAdapter', [
    '$rootScope', '$timeout',
    function($rootScope, $timeout) {
        var initialized = false;

        this.init = function(modal) {
            if (!initialized) {
                // ng-click is getting compiled correctly,
                // manually adding a click event instead
            if (jQuery.fn.jquery.split('.')[0] === '3') {
                modal.find('.jv-modal-close').on('click', function() {
                    $timeout(this.hideModal);
                }.bind(this));
            } else {
                modal.find('.jv-modal-close').click(function() {
                    $timeout(this.hideModal);
                }.bind(this));
            }
            initialized = true;
            }
        };

        this.injectContentsInModal = function(contents) {
            /*
                This takes html returned by engage endpoints
                and puts the markup in the right place basically
                duplicating the logic in the modal controller.

                We're doing it this way because old engage modals were
                designed to reuse one element so this keeps much of the
                logic unchanged.
             */
            var contentFragment = angular.element(contents);
            var modal = angular.element('#jv-modalDialog-new');
            contentFragment.attr('class', 'jv-modal-adapter');
            contentFragment.find('.jv-modalHeader').attr('class', 'jv-modal-header');
            contentFragment.find('.jv-actionClose').remove();
            contentFragment.find('.jv-modalContentWrapper').attr('class', 'jv-modal-content');
            modal.find('.jv-modal-adapter').remove();
            modal.find('.jv-modal').prepend(contentFragment);
            this.init(modal);
        };

        this.showModal = function(contents) {
            if (contents) {
                this.injectContentsInModal(contents);
            }
            $rootScope.showNewModal = true;
        };

        this.hideModal = function() {
            $rootScope.showNewModal = false;
        };
    }
]);